(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.swiper.about-gallery-wrapper').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            centeredSlides: true,
            mousewheel: { forceToAxis: true },
            cssMode: true,
            loop: true,
            breakpoints: {
                1024: {
                    centeredSlides: false,
                    loop: false
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-posts"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.hp-blog-posts').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            cssMode: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            breakpoints: {
                700: {
                    centeredSlides: false,
                    loop: false,
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.caterogy-cards-slider').forEach(elem => {
        new Swiper(elem, {
            slidesPerView: 'auto',
            cssMode: true,
            mousewheel: { forceToAxis: true, releaseOnEdges: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                700: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    loop: false,
                },
                1440: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    loop: false,
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelectorAll('.tab-button').length > 0){
      const tabs = document.querySelectorAll('.tab-button');
      tabs.forEach(tab => {
            tab.addEventListener('click', function() {
                tabs.forEach(t => {
                    t.classList.remove('active');
                });
                this.classList.add('active');
                const section = document.querySelector(tab.getAttribute('data-href'));
                if (section){
                  let scrollDiv = section.offsetTop - 100;
                  window.scrollTo({ top: scrollDiv, behavior: 'smooth'});
                } 
            });
      });
    } 
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-reviews"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.featured-review-blocks').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            loop: true,
            centeredSlides: true,
            cssMode: true,
            mousewheel: { forceToAxis: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                700: {
                    centeredSlides: false,
                    loop: false,
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-banner"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.hero-banner-images').forEach(elem => {
        new Swiper(elem, {
            slidesPerView: 1,
            pagination: {
                el: elem.querySelector('.swiper-pagination'),
                clickable: true
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    if(document.querySelector('.blog_post_metafield_content-inner.images') && window.innerWidth < 700){
        new Swiper('.blog_post_metafield_content-inner.images .content_description', {
            slidesPerView: 'auto',
            cssMode: true,
            loop: true,
            mousewheel: { forceToAxis: true }
        })
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', (event) => {
    if(document.querySelectorAll('.copy_coupon_btn').length > 0){
      document.querySelectorAll('.copy_coupon_btn').forEach(function(elem){
        elem.onclick = function(){
          navigator.clipboard.writeText(this.getAttribute('data-code'));
          let prompt = document.createElement('div');
          prompt.classList.add('confirm-prompt');
          prompt.textContent = 'Copied to Clipboard!';
          document.querySelector('body').appendChild(prompt);
          setTimeout(function(){
            document.querySelector('.confirm-prompt').remove();
          }, 2000);
        }
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.media-page-slider').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            loop: true,
            mousewheel: { forceToAxis: true },
            cssMode: true,
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["media-slideshow"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.media-page-slider').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            loop: true,
            mousewheel: { forceToAxis: true },
            autoHeight: false,
            cssMode: true,
            navigation: {
                nextEl: ".swiper-next",
                prevEl: ".swiper-prev",
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-benefits"] && !Shopify.designMode) return;
  try {
    
  /*document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.product-benefits-images').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            speed: 6000,
            autoplay: {
                disableOnInteraction: false
            },
            mousewheel: { forceToAxis: true },
            breakpoints: {
                700: {
                    centeredSlides: false
                }
            }
        })
    });
  });*/

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-cards"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.products-list').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            cssMode: true,
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true, releaseOnEdges: true },
            pagination: {
                el: elem.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                700: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    loop: false,
                },
                1440: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    loop: false,
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-highlights"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.product-highlights-tab').forEach(function(elem){
        elem.onclick = function(){
            let tabIndex = elem.getAttribute('data-index');
            let parentElem = elem.closest('.section');
            parentElem.querySelector('.product-highlights-tab-content.active').classList.remove('active');
            parentElem.querySelector('.product-highlights-tab-content[data-index="'+tabIndex+'"]').classList.add('active');
            parentElem.querySelector('.product-highlights-tab.active').classList.remove('active');
            elem.classList.add('active');
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-ingredients"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    if(document.querySelectorAll('.ingredients-popup-link').length > 0){
        document.querySelectorAll('.ingredients-popup-link').forEach(function(elem){
            elem.onclick = function(){
                document.querySelector('.ingredients-popup-wrapper').style.display = 'block';
            }
        });

        document.querySelector('.ingredients-popup-wrapper').onclick = function(evt){
            if(!evt.target.closest('.ingredient-popup-content'))
                document.querySelector('.ingredients-popup-wrapper').style.display = 'none';
        }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["section-faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function(){
    document.querySelectorAll('.faq-question').forEach(function(elem){
        elem.onclick = function(){
            let superParent = elem.closest('.product-faq-section');
            if(superParent.querySelector('.product-faq-block.open')){
                if(superParent.querySelector('.product-faq-block') != elem.parentElement){
                    superParent.querySelector('.product-faq-block.open').classList.remove('open');
                }
            }
            elem.parentElement.classList.toggle('open');
        }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-video-embeds"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    document.querySelectorAll('.video-list').forEach(function(elem){
        new Swiper(elem, {
            slidesPerView: 'auto',
            centeredSlides: true,
            loop: true,
            mousewheel: { forceToAxis: true },
            cssMode: true,
            pagination: {
                el: elem.querySelector('.swiper-pagination'),
                clickable: true
            },
            breakpoints: {
                700: {
                    slidesPerView: 3,
                    centeredSlides: false,
                    loop: false,
                },
                1440: {
                    slidesPerView: 4,
                    centeredSlides: false,
                    loop: false,
                }
            }
        })
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["typewrite-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener("DOMContentLoaded", function () {
    let text = document.querySelector('.store_text p').innerHTML;
    new TypeIt("#scrolling-text__text", {
        speed: 50,
        startDelay: 900,
        loop: false,
        cursor: '',
        waitUntilVisible: true
    })
    .type(text, { delay: 100 })
    .go();
  });

  } catch(e) { console.error(e); }
})();
})();
